import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';

import store from './store';
import history from './history';
import Root from './components/Root';
import clerkConfig from './config/clerk';

import './i18n';

// Configuración de Clerk
const clerkPublishableKey = clerkConfig.getPublishableKey();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  React.createElement(
    ClerkProvider,
    {
      publishableKey: clerkPublishableKey,
      appearance: clerkConfig.appearance,
      navigate: (to) => history.push(to),
      // Configuración adicional para páginas hosted
      options: {
        layout: {
          logoImageUrl: '/shakkii logo multicolor.jpeg',
          applicationName: 'Shakkii',
        },
      },
    },
    React.createElement(Root, { store, history })
  )
);
